//**auto-generated don't edit this code**//
import {ContractHttpClient} from '@esgi/contracts';
import {Observable} from 'rxjs';
import {InModel} from '../../../../types/esgi.schools/queries/esgi.apigateway/profiles/dictionaries/federal-districts/in-model';
import {OutModel} from '../../../../types/esgi.schools/queries/esgi.apigateway/profiles/dictionaries/federal-districts/out-model';

export function federalDistricts(httpClient: ContractHttpClient) {
	return (inModel: InModel): Observable<OutModel> => {
		return httpClient.request<OutModel>(
			'GET',
			'/profiles/common/federal-districts',
			inModel,
		).asObservable();
	};
}
